import Box from '@mui/material/Box';
import React, { memo } from 'react';
import { useIntl } from 'react-intl';

import IconSurroundingsCourt from '../Icons/Surroundings/IconSurroundingsCourt';
import IconSurroundingsField from '../Icons/Surroundings/IconSurroundingsField';
import IconSurroundingsForest from '../Icons/Surroundings/IconSurroundingsForest';
import IconSurroundingsHouse from '../Icons/Surroundings/IconSurroundingsHouse';
import IconSurroundingsLake from '../Icons/Surroundings/IconSurroundingsLake';
import IconSurroundingsMeadow from '../Icons/Surroundings/IconSurroundingsMeadow';
import IconSurroundingsMountain from '../Icons/Surroundings/IconSurroundingsMountain';
import IconSurroundingsRiver from '../Icons/Surroundings/IconSurroundingsRiver';
import IconSurroundingsSea from '../Icons/Surroundings/IconSurroundingsSea';
import ItemChip from './ItemChip';

const getIcon = (optionKey) => {
  switch (optionKey) {
    case 'court':
      return <IconSurroundingsCourt />;
    case 'field':
      return <IconSurroundingsField />;
    case 'forest':
      return <IconSurroundingsForest />;
    case 'house':
      return <IconSurroundingsHouse />;
    case 'lake':
      return <IconSurroundingsLake />;
    case 'meadow':
      return <IconSurroundingsMeadow />;
    case 'mountain':
      return <IconSurroundingsMountain />;
    case 'river':
      return <IconSurroundingsRiver />;
    case 'sea':
      return <IconSurroundingsSea />;
    default:
      return null;
  }
};

const surroundingsPropertyGroupDefaultPropSelectedOptions = [];

/**
 * SurroundingsPropertyGroup renders a list of options as chips, indicating selected and non-selected items.
 *
 * It's used for displaying a group of selectable properties, such as amenities or activities,
 * in a form where users can see their current selections at a glance.
 *
 * Props:
 *   - id (string): A unique identifier for the group of options.
 *   - options (array): An array of option objects, each containing a `key` and `label`.
 *   - selectedOptions (array): An array of selected option keys.
 *   - intl (object): The internationalization object provided by react-intl's `injectIntl`.
 *   - showNotSelectedItems (bool): Flag to show or hide non-selected items.
 *
 * Each option is rendered as an `ItemChip` component, which is responsible for the actual display
 * of the chip.
 */
const SurroundingsPropertyGroup = ({ options, selectedOptions = surroundingsPropertyGroupDefaultPropSelectedOptions, showNotSelectedItems = true }) => {
  const intl = useIntl();
  return (
    <Box>
      {options.map((option) => (
        <ItemChip
          icon={getIcon(option.key)}
          isSelected={selectedOptions.includes(option.key)}
          key={`${option.key}`}
          label={intl.formatMessage({ id: option.label })}
          showNotSelectedItems={showNotSelectedItems}
        />
      ))}
    </Box>
  );
};

export default memo(SurroundingsPropertyGroup);
